// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1n2rf","log":"ModalInventoryLogs_log__1Eq4r","date":"ModalInventoryLogs_date__3sxOy","userName":"ModalInventoryLogs_userName__1xMD2"};